export default __webpack_public_path__ + "static/media/TO.6f20db09.svg";